import HBButton from "@/components/HBButton";
import { ButtonProps } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

export default function PinDetailButton({
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <HBButton className={classNames(styles.btn, className)} {...props}>
      {children}
    </HBButton>
  );
}
